(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteral', 'apollo-boost'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteral'), require('apollo-boost'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteral, global.apolloBoost);
    global.utils = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteral2, _apolloBoost) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.checkLogin = exports.clearToken = exports.getToken = exports.setToken = exports.PGA_TOKEN_NAME = exports.GET_USER_DATA = undefined;

  var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  query User {\n    me {\n      id\n      primaryEmail\n      type\n      firstName\n      lastName\n      photo\n      class\n      type\n      displayName\n      role\n    }\n  }\n'], ['\n  query User {\n    me {\n      id\n      primaryEmail\n      type\n      firstName\n      lastName\n      photo\n      class\n      type\n      displayName\n      role\n    }\n  }\n']);

  var GET_USER_DATA = exports.GET_USER_DATA = (0, _apolloBoost.gql)(_templateObject);

  var PGA_TOKEN_NAME = exports.PGA_TOKEN_NAME = 'pgaIDToken';

  var sessionStorage = {};

  if (typeof window !== 'undefined') {
    sessionStorage = window.sessionStorage;
  }

  var setToken = exports.setToken = function setToken(token) {
    return sessionStorage.setItem(PGA_TOKEN_NAME, token);
  };

  var getToken = exports.getToken = function getToken() {
    return sessionStorage.getItem(PGA_TOKEN_NAME);
  };

  var clearToken = exports.clearToken = function clearToken() {
    return sessionStorage.removeItem(PGA_TOKEN_NAME);
  };

  var checkLogin = exports.checkLogin = function checkLogin(_ref) {
    var isLoggedIn = _ref.isLoggedIn,
        requiredRole = _ref.requiredRole,
        role = _ref.role;
    return isLoggedIn && (!requiredRole || requiredRole === role);
  };
});